@if ({}; as STATE) {
  <section class="subscriber-ads-card"></section>
}
